import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Button from '@/components/Buttons/Button';

const IconButton = forwardRef(({ 
  icon,
  title,
  accessibilityLabel = title,
  label,
  size = 'medium',
  height,
  width,
  iconSize = 18,
  isHovering = false,
  onPress,
  onMouseEnter,
  onMouseLeave,
  style,
  iconColor,
  hoverBackgroundColor,
  disabled = false,
  iconIsSolid = false,
  tooltip,
  ...props
}, ref) => {
  return (
    <Button
      ref={ref}
      prependIcon={icon}
      text={label}
      variant={isHovering ? 'secondary' : 'transparent'}
      size={size}
      // isRound={true}
      isDisabled={disabled}
      onPress={onPress}
      accessibilityLabel={accessibilityLabel}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      iconColor={iconColor}
      style={[
        style,
        height && { height },
        width && { width },
      ]}
      iconIsSolid={iconIsSolid}
      tooltip={tooltip}
      {...props}
    />
  );
});

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string,
  accessibilityLabel: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['extraSmall', 'small', 'medium', 'large']),
  height: PropTypes.number,
  width: PropTypes.number,
  iconSize: PropTypes.number,
  isHovering: PropTypes.bool,
  onPress: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  color: PropTypes.string,
  hoverBackgroundColor: PropTypes.string,
  disabled: PropTypes.bool,
  iconIsSolid: PropTypes.bool,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default React.memo(IconButton);
